exports = module.exports = require("../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cloud-variable-badge_badge_2kZVK {\n    padding: 0.5rem;\n    margin: 5px 0 8px 0;\n    border: 1px solid #b9d6ff;\n    background-color: #dbebff;\n    display: flex;\n    align-items: center;\n    border-radius: 0.5rem;\n}\n[theme=\"dark\"] .cloud-variable-badge_badge_2kZVK {\n    border-color: #203652;\n    background-color: #16202c;\n}\n.cloud-variable-badge_icon_3PN9C {\n    margin-right: 0.25rem;\n}\n[theme=\"dark\"] .cloud-variable-badge_icon_3PN9C {\n    filter: invert(100%);\n}\n.cloud-variable-badge_text_1V3lA {\n\n}\n", ""]);

// exports
exports.locals = {
	"badge": "cloud-variable-badge_badge_2kZVK",
	"icon": "cloud-variable-badge_icon_3PN9C",
	"text": "cloud-variable-badge_text_1V3lA"
};